import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { ModalRoutes } from './modal-routes.enum';

/** передаваемые параметры, в открываемое модальное окно  */
type ModalParams = Record<string, unknown>;

/**
 * Сервис для работы с модальными окнами.
 * Открывает/закрывает окна через дополнительный outlet (modal)
 */
@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private readonly router = inject(Router);

  private readonly storage: { params: ModalParams } = {
    params: {},
  };

  get params(): ModalParams {
    return this.storage.params;
  }

  set params(value: ModalParams) {
    this.storage.params = value;
  }

  /**
   * Открыть модальное окно
   * @param route - маршрут дополнительного modal outlet'a
   * @param params - словарь параметров
   */
  public showModal(route: ModalRoutes, params?: ModalParams): Promise<boolean> {
    if (params) {
      this.storage.params = params;
    }
    const path = ['modal', ...route.split('/')];
    return this.closeModal().then(() =>
      this.router.navigate([{ outlets: { modal: path } }], {
        skipLocationChange: true,
      })
    );
  }

  /**
   * Close the modal payment window
   */
  public closeModal(): Promise<boolean> {
    return this.router.navigate([{ outlets: { modal: null } }]);
  }
}
